import React from "react";

const Header = () => {
    return (
        <div className="row justify-content-center text-center mb-4">
            <h1 className="col-12 name">Mariam Rakka, PhD</h1>
            <p className="col-12 description">Senior Research Engineer @ Arm</p>
        </div>
    );
};

export default Header;
